// extracted by mini-css-extract-plugin
export var cartContainer = "_n6-4";
export var gray = "_n6-1";
export var itemContainer = "_n6-2";
export var itemDetails = "_n6-3";
export var strong = "_n6-0";